import LogRocket from 'logrocket';

import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const useLogRocket = () => {
  const user = useAppSelector(selectUser);
  const email = user?.attributes?.['email'] ?? '';
  const environment = import.meta.env.VITE_APP_ENV;

  LogRocket.identify(email, { environment });
};
